// data/manifest.json（フィールド → 出典）を引くための小さなヘルパー。
import type { DataSource, Manifest } from "../../schema/muni";

export const STALE_AFTER_DAYS = 180;

export function sourceForField(manifest: Manifest, fieldPath: string): DataSource | undefined {
  const sourceId = manifest.fieldSources[fieldPath];
  if (!sourceId) return undefined;
  return manifest.sources.find((s) => s.id === sourceId);
}

export function isStale(source: DataSource, now: Date = new Date()): boolean {
  const retrieved = new Date(source.retrievedAt).getTime();
  if (Number.isNaN(retrieved)) return false;
  const ageDays = (now.getTime() - retrieved) / (1000 * 60 * 60 * 24);
  return ageDays > STALE_AFTER_DAYS;
}
